
import Vue from "vue"
import { fade, lines } from '@/utils/gsap'

Vue.directive('gsap-fade', {
    inserted(el, binding) {
        const options = binding.value || {}

        if (options.onScroll) {
            options.scrollTrigger = el
        }

        fade(el, options)
    }
})

Vue.directive('gsap-lines', {
    inserted(el, binding) {
        const options = binding.value || {}

        if (options.onScroll) {
            options.scrollTrigger = el
        }

        lines(el, options)
    }
})
